import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
    return (
        <div className="App">
            <Header />
            <Hero />
            <Services />
            <About />
            <Contact />
            <Footer />
            
            {/* Floating Action Buttons */}
            <div className="action-buttons">
                <a href="https://wa.me/919745695978" target="_blank" rel="noopener noreferrer" className="action-btn whatsapp">
                    <i className="fab fa-whatsapp"></i>
                </a>
                <a href="tel:+919745695978" className="action-btn phone">
                    <i className="fas fa-phone"></i>
                </a>
                <a href="https://www.instagram.com/thakshaarchitects?igsh=b2k4ZDZjaXJoaHVi" target="_blank" rel="noopener noreferrer" className="action-btn instagram">
                    <i className="fab fa-instagram"></i>
                </a>
            </div>
        </div>
    );
}

export default App;